import React from "react"
import cogoToast from "cogo-toast"

const Tab2 = ({tab, setTab, userData, addTabData}) => {

    const handleSubmit = e =>  {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;
        const formData = new FormData(form);
        const obj = Object.fromEntries(formData.entries());
        const tab2Data = {};

        /* Personal Data Values Check */
        if (obj.gender && obj.marital && obj.birth){
            tab2Data.personalData = {
              "birthDay" : +obj.birth.split("-")[2],
              "birthMonth" : +obj.birth.split("-")[1],
              "birthYear" : +obj.birth.split("-")[0],
              "gender" : obj.gender,
              "marital" : obj.marital,
              "politicallyExposedNames" : obj.politicallyExposedNames
            }
        }
        else if (obj.gender || obj.marital || obj.birth){
            cogoToast.error("Personal Information fields can not to be partially filled");
            return
        }

        /* Next of Kin Values Check */
        if (obj.nextOfKinFirstName && obj.nextOfKinLastName && obj.nextOfKinEmail && obj.nextOfKinRelationship && obj.nextOfKinPhone){
            tab2Data.trustData = {
                ...tab2Data.trustData,
                nextOfKin: {
                    "firstName" : obj.nextOfKinFirstName,
                    "lastName" : obj.nextOfKinLastName,
                    "email" : obj.nextOfKinEmail,
                    "relationship" : obj.nextOfKinRelationship,
                    "phone" : obj.nextOfKinPhone
                }
            }
        }
        else if (obj.nextOfKinFirstName || obj.nextOfKinLastName || obj.nextOfKinEmail || obj.nextOfKinRelationship || obj.nextOfKinPhone){
            cogoToast.error("Next of Kin fields can not to be partially filled");
            return
        }

        /* Trust Person Values Check */
        if (obj.trustInfoFirstName && obj.trustInfoLastName && obj.trustInfoEmail && obj.trustInfoPhone){
            tab2Data.trustData = {
                ...tab2Data.trustData,
                trustInfo: {
                    "firstName" : obj.trustInfoFirstName,
                    "lastName" : obj.trustInfoLastName,
                    "email" : obj.trustInfoEmail,
                    "phone" : obj.trustInfoPhone
                }
            }
        }
        else if (obj.trustInfoFirstName || obj.trustInfoLastName || obj.trustInfoEmail || obj.trustInfoPhone){
            cogoToast.error("Trust Person fields can not to be partially filled");
            return
        }


        // Trust Data complete check
        if (!(tab2Data.trustData?.nextOfKin && tab2Data.trustData?.trustInfo) && (tab2Data.trustData?.nextOfKin || tab2Data.trustData?.trustInfo)){
            return cogoToast.error("Next of Kin and Trust Person fields can not to be partially filled");
        }

        /* Address Data Values Check */
        if (obj.street1 && obj.city && obj.postalCode && obj.province  && obj.country){
            tab2Data.addressData = {
                "city" : obj.city,
                "country" : obj.country,
                "postalCode" : obj.postalCode,
                "province" : obj.province,
                "street1" : obj.street1,
                "street2" : obj.street2 
              }
        }
        else if (obj.street1 || obj.city || obj.postalCode || obj.province  || obj.country){
            cogoToast.error("Address Information can not to be partially filled");
            return
        }

        addTabData({tab2: tab2Data});
        setTab(3);
    }
    
    /* Get Default date of birth value */
    const dateDefaultValue = _ => {
        if (userData?.tab2?.personalData?.birthDay){
            let year = userData.tab2?.personalData.birthYear;
            let month = userData.tab2.personalData.birthMonth
            month = month >= 10 ? month : `0${month}`;
            let day = userData.tab2.personalData.birthDay
            day = day >= 10 ? day : `0${day}`;
            return `${year}-${month}-${day}`; 
        }
        else{
            return "";
        }
    }

    const maxBirthDate = new Date();
    maxBirthDate.setFullYear(maxBirthDate.getFullYear() - 18);

    const minBirthDate = new Date();
    minBirthDate.setFullYear(minBirthDate.getFullYear() - 100);

    return  <form
                onSubmit={handleSubmit} 
                className="form mt-0 mt-lg-10" 
            >
                <div 
                    className="pb-5" 
                    data-wizard-type="step-content" 
                    data-wizard-state={tab === 2 ? "current" : ""}
                >
                    <div className="mb-10 h3 font-weight-bold text-dark">User Personal Information</div>
                    
                    <div className="row">
                        <div className="col-xl-6">
                            {/* <!--begin::Input--> */}
                            <div className="form-group">
                                <label>Gender</label>
                                <select 
                                    name="gender"
                                    defaultValue={userData?.tab2?.personalData?.gender}
                                    className="form-control form-control-solid form-control-lg"
                                >
                                    <option value="">Select</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                </select>
                            </div>
                            {/* <!--end::Input--> */}
                        </div>
                        <div className="col-xl-6">
                            {/* <!--begin::Select--> */}
                            <div className="form-group">
                                <label>Marital Status</label>
                                <select 
                                    name="marital" 
                                    defaultValue={userData?.tab2?.personalData?.marital}
                                    className="form-control form-control-solid form-control-lg"
                                >
                                    <option value="">Select</option>
                                    <option value="SINGLE">Single</option>
                                    <option value="DIVORCED">Divorced</option>
                                    <option value="MARRIED">Married</option>
                                    <option value="WIDOWED">Widowed</option>
                                    <option value="PARTNER">Domestic Partner</option>
                                </select>
                            </div>
                            {/* <!--end::Select--> */}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xl-6">
                            {/* <!--begin::Input--> */}
                            <div className="form-group">
                                <label>Date of Birth</label>
                                <input 
                                    type="date" 
                                    defaultValue={dateDefaultValue()}
                                    max={maxBirthDate.toISOString().split('T')[0]}
                                    min={minBirthDate.toISOString().split('T')[0]}
                                    className="form-control form-control-solid form-control-lg" 
                                    name="birth" 
                                />
                            </div>
                            {/* <!--end::Input--> */}
                        </div>
                        <div className="col-xl-6">
                            {/* <!--begin::Select--> */}
                            <div className="form-group">
                                
                                <label>Politically exposed person</label>
                                <input 
                                    type="text" 
                                    defaultValue={userData?.tab2?.personalData?.politicallyExposedNames}
                                    className="form-control form-control-solid form-control-lg" 
                                    name="politicallyExposedNames" 
                                />
                            </div>
                            {/* <!--end::Select--> */}
                        </div>
                    </div>
                    
                    <div className="my-10 h3 font-weight-bold text-dark">User Next of Kin</div>
                    <div className="row">
                        <div className="col-xl-6">
                            {/* <!--begin::Input--> */}
                            <div className="form-group">
                                <label>First Name</label>
                                <input 
                                    type="text" 
                                    className="form-control form-control-solid form-control-lg" 
                                    name="nextOfKinFirstName" 
                                    defaultValue={userData?.tab2?.trustData?.nextOfKin?.firstName}
                                />
                            </div>
                            {/* <!--end::Input--> */}
                        </div>
                        <div className="col-xl-6">
                            {/* <!--begin::Input--> */}
                            <div className="form-group">
                                <label>Last Name</label>
                                <input 
                                    type="text" 
                                    defaultValue={userData?.tab2?.trustData?.nextOfKin?.lastName}
                                    className="form-control form-control-solid form-control-lg" 
                                    name="nextOfKinLastName"
                                />
                            </div>
                            {/* <!--end::Input--> */}
                        </div>
                    </div>
                    {/* <!--end::Input--> */}

                    {/* <!--end::Input--> */}
                    <div className="row">
                        <div className="col-xl-12">
                            {/* <!--begin::Input--> */}
                            <div className="form-group">
                                <label>Email</label>
                                <input 
                                    type="email" 
                                    defaultValue={userData?.tab2?.trustData?.nextOfKin?.email}
                                    className="form-control form-control-solid form-control-lg" 
                                    name="nextOfKinEmail"
                                />
                            </div>
                            {/* <!--end::Input--> */}
                        </div>
                        {/* <!--end::Input--> */}
                    </div>

                    {/* <!--end::Input--> */}
                    <div className="row">
                        <div className="col-xl-6">
                            {/* <!--begin::Input--> */}
                            <div className="form-group">
                                <label>Relationship</label>
                                <input 
                                    type="text" 
                                    defaultValue={userData?.tab2?.trustData?.nextOfKin?.relationship}
                                    className="form-control form-control-solid form-control-lg" 
                                    name="nextOfKinRelationship"
                                />
                            </div>
                            {/* <!--end::Input--> */}
                        </div>
                        <div className="col-xl-6">
                            {/* <!--begin::Input--> */}
                            <div className="form-group">
                                <label>Phone</label>
                                <input 
                                    type="text" 
                                    defaultValue={userData?.tab2?.trustData?.nextOfKin?.phone}
                                    className="form-control form-control-solid form-control-lg" 
                                    name="nextOfKinPhone"
                                />
                            </div>
                            {/* <!--end::Input--> */}
                        </div>
                    </div>
                    {/* <!--end::Input--> */}



                    <div className="my-10 h3 font-weight-bold text-dark">User Trust Person</div>
                    <div className="row">
                        <div className="col-xl-6">
                            {/* <!--begin::Input--> */}
                            <div className="form-group">
                                <label>First Name</label>
                                <input 
                                    type="text" 
                                    className="form-control form-control-solid form-control-lg" 
                                    name="trustInfoFirstName" 
                                    defaultValue={userData?.tab2?.trustData?.trustInfo?.firstName}
                                />
                            </div>
                            {/* <!--end::Input--> */}
                        </div>
                        <div className="col-xl-6">
                            {/* <!--begin::Input--> */}
                            <div className="form-group">
                                <label>Last Name</label>
                                <input 
                                    type="text" 
                                    defaultValue={userData?.tab2?.trustData?.trustInfo?.lastName}
                                    className="form-control form-control-solid form-control-lg" 
                                    name="trustInfoLastName"
                                />
                            </div>
                            {/* <!--end::Input--> */}
                        </div>
                    </div>
                    {/* <!--end::Input--> */}

                    {/* <!--end::Input--> */}
                    <div className="row">
                        <div className="col-xl-6">
                            {/* <!--begin::Input--> */}
                            <div className="form-group">
                                <label>Email</label>
                                <input 
                                    type="email" 
                                    defaultValue={userData?.tab2?.trustData?.trustInfo?.email}
                                    className="form-control form-control-solid form-control-lg" 
                                    name="trustInfoEmail"
                                />
                            </div>
                            {/* <!--end::Input--> */}
                        </div>
                        <div className="col-xl-6">
                            {/* <!--begin::Input--> */}
                            <div className="form-group">
                                <label>Phone</label>
                                <input 
                                    type="text" 
                                    defaultValue={userData?.tab2?.trustData?.trustInfo?.phone}
                                    className="form-control form-control-solid form-control-lg" 
                                    name="trustInfoPhone"
                                />
                            </div>
                            {/* <!--end::Input--> */}
                        </div>
                    </div>
                    {/* <!--end::Input--> */}



                    <div className="my-10 h3 font-weight-bold text-dark">User Address Details</div>

                    <div className="form-group">
                        <label>Address Line 1</label>
                        <input 
                            type="text" 
                            defaultValue={userData?.tab2?.addressData?.street1}
                            className="form-control form-control-solid form-control-lg" 
                            name="street1" 
                        />
                    </div>
                    {/* <!--end::Input--> */}
                    {/* <!--begin::Input--> */}
                    <div className="form-group">
                        <label>Address Line 2</label>
                        <input 
                            type="text" 
                            defaultValue={userData?.tab2?.addressData?.street2}
                            className="form-control form-control-solid form-control-lg" 
                            name="street2"
                        />
                    </div>
                    {/* <!--end::Input--> */}
                    <div className="row">
                        <div className="col-xl-6">
                            {/* <!--begin::Input--> */}
                            <div className="form-group">
                                <label>Postcode</label>
                                <input 
                                    type="text" 
                                    defaultValue={userData?.tab2?.addressData?.postalCode}
                                    className="form-control form-control-solid form-control-lg" 
                                    name="postalCode"
                                />
                            </div>
                            {/* <!--end::Input--> */}
                        </div>
                        <div className="col-xl-6">
                            {/* <!--begin::Input--> */}
                            <div className="form-group">
                                <label>City</label>
                                <input 
                                    type="text" 
                                    defaultValue={userData?.tab2?.addressData?.city}
                                    className="form-control form-control-solid form-control-lg" 
                                    name="city"
                                />
                            </div>
                            {/* <!--end::Input--> */}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-6">
                            {/* <!--begin::Input--> */}
                            <div className="form-group">
                                <label>State / Province</label>
                                <input 
                                    type="text" 
                                    defaultValue={userData?.tab2?.addressData?.province}
                                    className="form-control form-control-solid form-control-lg" 
                                    name="province"
                                />
                            </div>
                            {/* <!--end::Input--> */}
                        </div>
                        <div className="col-xl-6">
                            {/* <!--begin::Select--> */}
                            <div className="form-group">
                                <label>Country</label>
                                <select 
                                    name="country" 
                                    defaultValue={userData?.tab2?.addressData?.country}
                                    className="form-control form-control-solid form-control-lg"
                                >
                                    <option value="">Select</option>
                                    <option value="AFG">Afghanistan</option>
                                    <option value="ALA">Åland Islands</option>
                                    <option value="ALB">Albania</option>
                                    <option value="DZA">Algeria</option>
                                    <option value="ASM">American Samoa</option>
                                    <option value="AND">Andorra</option>
                                    <option value="AGO">Angola</option>
                                    <option value="AIA">Anguilla</option>
                                    <option value="ATA">Antarctica</option>
                                    <option value="ATG">Antigua and Barbuda</option>
                                    <option value="ARG">Argentina</option>
                                    <option value="ARM">Armenia</option>
                                    <option value="ABW">Aruba</option>
                                    <option value="AUS">Australia</option>
                                    <option value="AUT">Austria</option>
                                    <option value="AZE">Azerbaijan</option>
                                    <option value="BHS">Bahamas</option>
                                    <option value="BHR">Bahrain</option>
                                    <option value="BGD">Bangladesh</option>
                                    <option value="BRB">Barbados</option>
                                    <option value="BLR">Belarus</option>
                                    <option value="BEL">Belgium</option>
                                    <option value="BLZ">Belize</option>
                                    <option value="BEN">Benin</option>
                                    <option value="BMU">Bermuda</option>
                                    <option value="BTN">Bhutan</option>
                                    <option value="BOL">Bolivia, Plurinational State of</option>
                                    <option value="BES">Bonaire, Sint Eustatius and Saba</option>
                                    <option value="BIH">Bosnia and Herzegovina</option>
                                    <option value="BWA">Botswana</option>
                                    <option value="BVT">Bouvet Island</option>
                                    <option value="BRA">Brazil</option>
                                    <option value="IOT">British Indian Ocean Territory</option>
                                    <option value="BRN">Brunei Darussalam</option>
                                    <option value="BGR">Bulgaria</option>
                                    <option value="BFA">Burkina Faso</option>
                                    <option value="BDI">Burundi</option>
                                    <option value="KHM">Cambodia</option>
                                    <option value="CMR">Cameroon</option>
                                    <option value="CAN">Canada</option>
                                    <option value="CPV">Cape Verde</option>
                                    <option value="CYM">Cayman Islands</option>
                                    <option value="CAF">Central African Republic</option>
                                    <option value="TCD">Chad</option>
                                    <option value="CHL">Chile</option>
                                    <option value="CHN">China</option>
                                    <option value="CXR">Christmas Island</option>
                                    <option value="CCK">Cocos (Keeling) Islands</option>
                                    <option value="COL">Colombia</option>
                                    <option value="COM">Comoros</option>
                                    <option value="COG">Congo</option>
                                    <option value="COD">Congo, the Democratic Republic of the</option>
                                    <option value="COK">Cook Islands</option>
                                    <option value="CRI">Costa Rica</option>
                                    <option value="CIV">Côte d'Ivoire</option>
                                    <option value="HRV">Croatia</option>
                                    <option value="CUB">Cuba</option>
                                    <option value="CUW">Curaçao</option>
                                    <option value="CYP">Cyprus</option>
                                    <option value="CZE">Czech Republic</option>
                                    <option value="DNK">Denmark</option>
                                    <option value="DJI">Djibouti</option>
                                    <option value="DMA">Dominica</option>
                                    <option value="DOM">Dominican Republic</option>
                                    <option value="ECU">Ecuador</option>
                                    <option value="EGY">Egypt</option>
                                    <option value="SLV">El Salvador</option>
                                    <option value="GNQ">Equatorial Guinea</option>
                                    <option value="ERI">Eritrea</option>
                                    <option value="EST">Estonia</option>
                                    <option value="ETH">Ethiopia</option>
                                    <option value="FLK">Falkland Islands (Malvinas)</option>
                                    <option value="FRO">Faroe Islands</option>
                                    <option value="FJI">Fiji</option>
                                    <option value="FIN">Finland</option>
                                    <option value="FRA">France</option>
                                    <option value="GUF">French Guiana</option>
                                    <option value="PYF">French Polynesia</option>
                                    <option value="ATF">French Southern Territories</option>
                                    <option value="GAB">Gabon</option>
                                    <option value="GMB">Gambia</option>
                                    <option value="GEO">Georgia</option>
                                    <option value="DEU">Germany</option>
                                    <option value="GHA">Ghana</option>
                                    <option value="GIB">Gibraltar</option>
                                    <option value="GRC">Greece</option>
                                    <option value="GRL">Greenland</option>
                                    <option value="GRD">Grenada</option>
                                    <option value="GLP">Guadeloupe</option>
                                    <option value="GUM">Guam</option>
                                    <option value="GTM">Guatemala</option>
                                    <option value="GGY">Guernsey</option>
                                    <option value="GIN">Guinea</option>
                                    <option value="GNB">Guinea-Bissau</option>
                                    <option value="GUY">Guyana</option>
                                    <option value="HTI">Haiti</option>
                                    <option value="HMD">Heard Island and McDonald Islands</option>
                                    <option value="VAT">Holy See (Vatican City State)</option>
                                    <option value="HND">Honduras</option>
                                    <option value="HKG">Hong Kong</option>
                                    <option value="HUN">Hungary</option>
                                    <option value="ISL">Iceland</option>
                                    <option value="IND">India</option>
                                    <option value="IDN">Indonesia</option>
                                    <option value="IRN">Iran, Islamic Republic of</option>
                                    <option value="IRQ">Iraq</option>
                                    <option value="IRL">Ireland</option>
                                    <option value="IMN">Isle of Man</option>
                                    <option value="ISR">Israel</option>
                                    <option value="ITA">Italy</option>
                                    <option value="JAM">Jamaica</option>
                                    <option value="JPN">Japan</option>
                                    <option value="JEY">Jersey</option>
                                    <option value="JOR">Jordan</option>
                                    <option value="KAZ">Kazakhstan</option>
                                    <option value="KEN">Kenya</option>
                                    <option value="KIR">Kiribati</option>
                                    <option value="PRK">Korea, Democratic People's Republic of</option>
                                    <option value="KOR">Korea, Republic of</option>
                                    <option value="KWT">Kuwait</option>
                                    <option value="KGZ">Kyrgyzstan</option>
                                    <option value="LAO">Lao People's Democratic Republic</option>
                                    <option value="LVA">Latvia</option>
                                    <option value="LBN">Lebanon</option>
                                    <option value="LSO">Lesotho</option>
                                    <option value="LBR">Liberia</option>
                                    <option value="LBY">Libya</option>
                                    <option value="LIE">Liechtenstein</option>
                                    <option value="LTU">Lithuania</option>
                                    <option value="LUX">Luxembourg</option>
                                    <option value="MAC">Macao</option>
                                    <option value="MKD">Macedonia, the former Yugoslav Republic of</option>
                                    <option value="MDG">Madagascar</option>
                                    <option value="MWI">Malawi</option>
                                    <option value="MYS">Malaysia</option>
                                    <option value="MDV">Maldives</option>
                                    <option value="MLI">Mali</option>
                                    <option value="MLT">Malta</option>
                                    <option value="MHL">Marshall Islands</option>
                                    <option value="MTQ">Martinique</option>
                                    <option value="MRT">Mauritania</option>
                                    <option value="MUS">Mauritius</option>
                                    <option value="MYT">Mayotte</option>
                                    <option value="MEX">Mexico</option>
                                    <option value="FSM">Micronesia, Federated States of</option>
                                    <option value="MDA">Moldova, Republic of</option>
                                    <option value="MCO">Monaco</option>
                                    <option value="MNG">Mongolia</option>
                                    <option value="MNE">Montenegro</option>
                                    <option value="MSR">Montserrat</option>
                                    <option value="MAR">Morocco</option>
                                    <option value="MOZ">Mozambique</option>
                                    <option value="MMR">Myanmar</option>
                                    <option value="NAM">Namibia</option>
                                    <option value="NRU">Nauru</option>
                                    <option value="NPL">Nepal</option>
                                    <option value="NLD">Netherlands</option>
                                    <option value="NCL">New Caledonia</option>
                                    <option value="NZL">New Zealand</option>
                                    <option value="NIC">Nicaragua</option>
                                    <option value="NER">Niger</option>
                                    <option value="NGA">Nigeria</option>
                                    <option value="NIU">Niue</option>
                                    <option value="NFK">Norfolk Island</option>
                                    <option value="MNP">Northern Mariana Islands</option>
                                    <option value="NOR">Norway</option>
                                    <option value="OMN">Oman</option>
                                    <option value="PAK">Pakistan</option>
                                    <option value="PLW">Palau</option>
                                    <option value="PSE">Palestinian Territory, Occupied</option>
                                    <option value="PAN">Panama</option>
                                    <option value="PNG">Papua New Guinea</option>
                                    <option value="PRY">Paraguay</option>
                                    <option value="PER">Peru</option>
                                    <option value="PHL">Philippines</option>
                                    <option value="PCN">Pitcairn</option>
                                    <option value="POL">Poland</option>
                                    <option value="PRT">Portugal</option>
                                    <option value="PRI">Puerto Rico</option>
                                    <option value="QAT">Qatar</option>
                                    <option value="REU">Réunion</option>
                                    <option value="ROU">Romania</option>
                                    <option value="RUS">Russian Federation</option>
                                    <option value="RWA">Rwanda</option>
                                    <option value="BLM">Saint Barthélemy</option>
                                    <option value="SHN">Saint Helena, Ascension and Tristan da Cunha</option>
                                    <option value="KNA">Saint Kitts and Nevis</option>
                                    <option value="LCA">Saint Lucia</option>
                                    <option value="MAF">Saint Martin (French part)</option>
                                    <option value="SPM">Saint Pierre and Miquelon</option>
                                    <option value="VCT">Saint Vincent and the Grenadines</option>
                                    <option value="WSM">Samoa</option>
                                    <option value="SMR">San Marino</option>
                                    <option value="STP">Sao Tome and Principe</option>
                                    <option value="SAU">Saudi Arabia</option>
                                    <option value="SEN">Senegal</option>
                                    <option value="SRB">Serbia</option>
                                    <option value="SYC">Seychelles</option>
                                    <option value="SLE">Sierra Leone</option>
                                    <option value="SGP">Singapore</option>
                                    <option value="SXM">Sint Maarten (Dutch part)</option>
                                    <option value="SVK">Slovakia</option>
                                    <option value="SVN">Slovenia</option>
                                    <option value="SLB">Solomon Islands</option>
                                    <option value="SOM">Somalia</option>
                                    <option value="ZAF">South Africa</option>
                                    <option value="SGS">South Georgia and the South Sandwich Islands</option>
                                    <option value="SSD">South Sudan</option>
                                    <option value="ESP">Spain</option>
                                    <option value="LKA">Sri Lanka</option>
                                    <option value="SDN">Sudan</option>
                                    <option value="SUR">Suriname</option>
                                    <option value="SJM">Svalbard and Jan Mayen</option>
                                    <option value="SWZ">Swaziland</option>
                                    <option value="SWE">Sweden</option>
                                    <option value="CHE">Switzerland</option>
                                    <option value="SYR">Syrian Arab Republic</option>
                                    <option value="TWN">Taiwan, Province of China</option>
                                    <option value="TJK">Tajikistan</option>
                                    <option value="TZA">Tanzania, United Republic of</option>
                                    <option value="THA">Thailand</option>
                                    <option value="TLS">Timor-Leste</option>
                                    <option value="TGO">Togo</option>
                                    <option value="TKL">Tokelau</option>
                                    <option value="TON">Tonga</option>
                                    <option value="TTO">Trinidad and Tobago</option>
                                    <option value="TUN">Tunisia</option>
                                    <option value="TUR">Turkey</option>
                                    <option value="TKM">Turkmenistan</option>
                                    <option value="TCA">Turks and Caicos Islands</option>
                                    <option value="TUV">Tuvalu</option>
                                    <option value="UGA">Uganda</option>
                                    <option value="UKR">Ukraine</option>
                                    <option value="ARE">United Arab Emirates</option>
                                    <option value="GBR">United Kingdom</option>
                                    <option value="USA">United States</option>
                                    <option value="UMI">United States Minor Outlying Islands</option>
                                    <option value="URY">Uruguay</option>
                                    <option value="UZB">Uzbekistan</option>
                                    <option value="VUT">Vanuatu</option>
                                    <option value="VEN">Venezuela, Bolivarian Republic of</option>
                                    <option value="VNM">Viet Nam</option>
                                    <option value="VGB">Virgin Islands, British</option>
                                    <option value="VIR">Virgin Islands, U.S.</option>
                                    <option value="WLF">Wallis and Futuna</option>
                                    <option value="ESH">Western Sahara</option>
                                    <option value="YEM">Yemen</option>
                                    <option value="ZMB">Zambia</option>
                                    <option value="ZWE">Zimbabwe</option>
                                </select>
                            </div>
                            {/* <!--end::Select--> */}
                        </div>
                    </div>

                    {/* <!--begin: Wizard Actions--> */}
                    <div className="d-flex justify-content-between border-top mt-5 pt-10">
                        <div className="mr-2">
                            <button
                                onClick={_ => setTab(1)} 
                                type="button" 
                                className="btn btn-light-primary font-weight-bolder text-uppercase px-9 py-4"
                            >
                                Previous
                            </button>
                        </div>
                        <div>
                            <button 
                                type="submit" 
                                className="btn btn-primary font-weight-bolder text-uppercase px-9 py-4"
                            >
                                Next
                            </button>
                        </div>
                    </div>
                    {/* <!--end: Wizard Actions--> */}
                </div>
            </form>
}

export default Tab2;